import ApartmentIcon from '@mui/icons-material/Apartment';
import DashboardIcon from '@mui/icons-material/Dashboard';
import EngineeringIcon from '@mui/icons-material/Engineering';
import HelpIcon from '@mui/icons-material/Help';
import PlumbingIcon from '@mui/icons-material/Plumbing';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import ScienceIcon from '@mui/icons-material/Science';
import SettingsIcon from '@mui/icons-material/Settings';
import { Box, Typography } from '@mui/material';
import FEATURE_FLAGS from 'config/featureFlags';
import useCASTFlags from 'hooks/useCASTFlags';
import ViewOption from './ViewOption';

type PropsType = {
  className: string;
};

const style = { cursor: 'pointer' };

const LeftBar = (props: PropsType) => {
  const { leadcast_predict_dashboard } = useCASTFlags([FEATURE_FLAGS.LEADCAST_PREDICT_DASHBOARD]);
  const predictFeatureEnabled = leadcast_predict_dashboard?.enabled;

  return (
    <>
      <Typography variant="leftNav" data-test-id="left-hand-nav">
        <Box className={props.className} sx={{ paddingTop: '4rem' }}>
          <div id="viewselection">
            <ViewOption
              text={'Inventory'}
              icon={<DashboardIcon style={style} fontSize="large" />}
              select="/Inventory"
            />
            <ViewOption
              text={'Sampling'}
              icon={<ScienceIcon style={style} fontSize="large" />}
              select="/Sampling"
            />
            <ViewOption
              text={'Replacement'}
              icon={<PlumbingIcon style={style} fontSize="large" />}
              select={'/Replacement'}
            />
            <ViewOption
              text={'Field App'}
              icon={<EngineeringIcon style={style} fontSize="large" />}
              select="/mobile"
            />
            {predictFeatureEnabled && (
              <ViewOption
                text={'Predict'}
                icon={<QueryStatsIcon style={style} fontSize="large" />}
                select={'/Predict'}
              />
            )}
            <ViewOption
              text={'S&D'}
              icon={<ApartmentIcon style={style} fontSize="large" />}
              select={'/SchoolAndDaycare'}
            />
          </div>
          <div id="viewselection">
            <ViewOption
              text={'Settings'}
              icon={<SettingsIcon style={style} fontSize="large" />}
              select="/Settings"
            />
            <ViewOption
              text={'Help'}
              icon={<HelpIcon style={style} fontSize="large" />}
              type={'menu'}
              select="/Help"
            />
          </div>
        </Box>
      </Typography>
    </>
  );
};

export default LeftBar;
